module.exports = __webpack_public_path__ + "static/media/exhibition_hover.99ecbbc3.svg";